import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-service-object-type-menu',
  templateUrl: './service-object-type-menu.component.html',
  styleUrls: ['./service-object-type-menu.component.css']
})
export class ServiceObjectTypeMenuComponent implements OnInit {
    serviceObjectTypeKeyno;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.serviceObjectTypeKeyno = this.stateService.getStateParams()['serviceobjecttype_keyno'];
    }

    private async loadMenu() {
        if (!!this.serviceObjectTypeKeyno) {
            this.menu = (await this.datatask.Post(1740, { serviceobjecttype_keyno: this.serviceObjectTypeKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    serviceobjecttype_keyno: number;
    serviceobjecttype_name: string;
    nbr_of_serviceobjecttypeints: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('serviceObjectTypeMenu', {
//        templateUrl: 'views/components/views/serviceObjectTypeMenu/serviceObjectTypeMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'serviceObjectTypeMenuService', function ($stateParams, serviceObjectTypeMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let serviceObjectTypeKeyno = $stateParams.serviceobjecttype_keyno;

//            vm.model = {
//                menu: {}
//            };

//            // #region VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            let loadMenu = function () {
//                serviceObjectTypeMenuService.getMenu({ serviceobjecttype_keyno: serviceObjectTypeKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.menu);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
